import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20home%20theater%20setup%20with%20large%20curved%20screen%20displaying%20vibrant%20cinematic%20content%2C%20warm%20ambient%20lighting%20with%20orange%20and%20gold%20accents%2C%20cozy%20dark%20room%20atmosphere%2C%20premium%20entertainment%20experience%2C%20cinematic%20photography%20with%20soft%20glow%20effects%2C%20elegant%20interior%20design&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="极速高清在线观看平台 - 随时随地畅享高清视频内容"
          title="极速高清在线观看平台"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <div className="w-2 h-2 rounded-full bg-primary-400 animate-pulse"></div>
          <span className="text-white/90 text-sm font-medium">5000万+用户在线观看首选平台</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          随时随地
          <span className="text-primary-400">在线观看</span>
          高清视频
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          极速、高清、无广告的在线观看体验。海量影视、综艺、纪录片供您选择，
          支持手机、平板、电脑多端同步，无需下载即可立即播放。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianying"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-fill mr-2"></i>
            立即在线观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/25 text-white rounded-full text-base font-medium hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-10 text-white/60 text-sm">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-primary-400"></i>
            <span>安全无广告</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-smartphone-line text-primary-400"></i>
            <span>多端同步</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-speed-up-line text-primary-400"></i>
            <span>极速加载</span>
          </div>
        </div>
      </div>
    </section>
  );
}